import React, { useState, useEffect } from "react";
import { Box, Select, SelectOption, Text } from "@showitinc/showit-wc";

import SiteDesignStore from "@/stores/SiteDesignStore";
import useStoreState from "../providers/useStoreState";
import DesignSettingBrandColorsPreview from "./DesignSettingBrandColorsPreview";
import styles from "./DesignSettingsBrandColors.module.css";

/**
 * Brand Colors tab component for Design Settings Modal
 * Provides interface for managing brand color palette
 */
const DesignSettingsBrandColors = ({ setTheme, preview }) => {
  const [overrideValue, setOverrideValue] = useState(null);

  const currentPage = useStoreState(
    SiteDesignStore,
    SiteDesignStore.getCurrentPage
  );

  const siteDesign = useStoreState(SiteDesignStore, SiteDesignStore.getDesign);
  const pages = siteDesign.getPageList({ withFolders: false }) ?? [];

  // doing this because the store is async and the page may not be loaded yet
  // resolves the dropdown flickering when the page is selected
  useEffect(() => {
    if (overrideValue && currentPage?.id === overrideValue) {
      setOverrideValue(null);
    }
  }, [currentPage?.id, overrideValue]);

  const handlePageChange = (e) => {
    const pageId = e.target.value;

    setOverrideValue(pageId);

    if (siteDesign && pageId) {
      const pageItem = siteDesign.getPageItem(pageId);
      if (pageItem) {
        SiteDesignStore.onSelectPage({ page: pageItem });
      }
    }
  };

  const displayValue = overrideValue || currentPage?.id || "";

  return (
    <>
      <Box className={styles["page-selection-wrapper"]}>
        <Select
          label="Page"
          value={displayValue}
          shift="left"
          onSISelect={handlePageChange}
        >
          {pages.map((page) => (
            <SelectOption key={page.get("id")} value={page.get("id")}>
              {page.get("name") || "Unnamed Page"}
            </SelectOption>
          ))}
        </Select>
      </Box>
      <DesignSettingBrandColorsPreview preview={preview} setTheme={setTheme} />
    </>
  );
};

export default DesignSettingsBrandColors;
